import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=091d49e4&scoped=true"
import script from "./Revenue.vue?vue&type=script&lang=js"
export * from "./Revenue.vue?vue&type=script&lang=js"
import style0 from "./Revenue.vue?vue&type=style&index=0&id=091d49e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091d49e4",
  null
  
)

export default component.exports